"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const index_1 = require("./index");
exports.default = (state = [], action) => {
    if (action.type === 'FETCH_EVENT_SCHEMAS_SUCCESS') {
        return [...action.eventSchemas];
    }
    return state;
};
exports.getEventSchemas = (state) => state;
exports.getSelectedSchemas = (state) => {
    const { eventSchemas } = state;
    const { eventName, eventNamespace } = index_1.getEditableCampaignEventTrigger(state);
    if (eventName.length !== 0) {
        const eventSchema = eventSchemas.find((schema) => schema.name === eventName && schema.namespace === eventNamespace);
        if (!!eventSchema) {
            return eventSchema.schema;
        }
    }
    return [];
};
exports.getComparisonOperatorDisplayValue = (comparisonOperator) => {
    const comparisonToDisplay = {
        BEGINS_WITH: 'begins with',
        ENDS_WITH: 'ends with',
        LIKE: 'matches',
        CONTAINS: 'contains',
        EQUAL_TO: 'equals',
        NOT_EQUAL_TO: 'does not equal',
        LESS_THAN: 'is less than',
        LESS_THAN_OR_EQUAL_TO: 'is less than or equal',
        GREATER_THAN: 'is greater than',
        GREATER_THAN_OR_EQUAL_TO: 'is greater than or equal',
        IN: 'is one of',
        BETWEEN: 'is between',
        GEO_WITHIN: 'is within',
        EXISTS: 'exists',
        IN_LIST: 'is in list',
    };
    return comparisonToDisplay[comparisonOperator];
};
exports.getSelectedPredicate = (state, index) => {
    const predicate = index_1.getEditableEventAttributesEventTriggerFilter(state);
    if (predicate === null) {
        return null;
    }
    return predicate.predicates[index];
};
